// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3gw22","addWidgetButton":"Header_addWidgetButton__26f5m","dashboardTabs":"Header_dashboardTabs__NKWqb","active":"Header_active__1mBa8"};